import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs'; 

@Injectable()
export class AddCsrfHeaderInterceptorService implements HttpInterceptor { 
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
 
    var requestToken = sessionStorage.getItem("XSRF-TOKEN");
    const reqH = requestToken && requestToken !=null ? req.clone({
      headers: req.headers.set("X-XSRF-TOKEN", requestToken)
    }) : req;
    return next.handle(reqH);
  } 
}
